import ProfileData from '../model/profileData';
import {
    FETCH_PROFILE_REQUEST,
    FETCH_PROFILE_SUCCESS,
    FETCH_PROFILE_ERROR,
    UPDATE_IMAGE_SUCCESS,
    UPDATE_IMAGE_ERROR,
    HIDE_PROFILE_LOADER,
    SHOW_PROFILE_LOADER,
    DELETE_IMAGE_SUCCESS,
    DELETE_IMAGE_ERROR,
    RESET_IMAGE_REQUEST,
    RESET_IMAGE_SUCCESS,
    FETCH_PROFILE_JSON_SUCCESS,
    FETCH_PROFILE_JSON_ERROR,
    CREATE_STATIC_QR_REQUEST,
    CREATE_STATIC_QR_SUCCESS,
    CREATE_STATIC_QR_ERROR,
    RESET_STATIC_QR_DATA,
} from './profile.constants';

const initialState = {
    data: {},
    error: {},
    isLoading: false,
    resetImage: false,
    updateImage: {
        isSuccess: false,
        message: '',
        isLoading: '',
        data: {},
    },
    deleteImage: {
        isSuccess: false,
        message: '',
        isLoading: '',
        data: {},
    },
    sdkData: {},
    createStaticQrData: {},
};

export const profileReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PROFILE_REQUEST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case FETCH_PROFILE_SUCCESS: {
            const profile = new ProfileData(action.payload);
            return {
                ...state,
                ...profile,
                isLoading: false,
                updateImage: { isSuccess: false },
            };
        }
        case FETCH_PROFILE_ERROR:
            return {
                ...state,
                isLoading: false,
                data: {},
                updateImage: { isSuccess: false },
            };
        case FETCH_PROFILE_JSON_SUCCESS:
            return { ...state, sdkData: { ...action.payload } };
        case FETCH_PROFILE_JSON_ERROR:
            return { ...state, sdkData: {} };
        case UPDATE_IMAGE_SUCCESS: {
            return {
                ...state,
                updateImage: { isSuccess: true, ...action.payload },
            };
        }
        case UPDATE_IMAGE_ERROR:
            return { ...state, updateImage: { ...action.payload } };
        case DELETE_IMAGE_SUCCESS:
            return {
                ...state,
                deleteImage: { isSuccess: true, ...action.payload },
            };
        case CREATE_STATIC_QR_REQUEST:
            return {
                ...state,
                isLoading: true,
                createStaticQrData: { isSuccess: false },
            };
        case CREATE_STATIC_QR_SUCCESS:
            return {
                ...state,
                createStaticQrData: { ...action.payload, isSuccess: true },
            };
        case CREATE_STATIC_QR_ERROR:
            return {
                ...state,
                createStaticQrData: { ...action.payload, isSuccess: false },
            };

        case RESET_STATIC_QR_DATA:
            return {
                ...state,
                createStaticQrData: initialState.createStaticQrData,
            };

        case DELETE_IMAGE_ERROR:
            return { ...state, deleteImage: { ...action.payload } };
        case HIDE_PROFILE_LOADER:
            return { ...state, isLoading: false };
        case RESET_IMAGE_REQUEST:
            return { ...state, resetImage: true };
        case RESET_IMAGE_SUCCESS:
            return { ...state, resetImage: false };
        case SHOW_PROFILE_LOADER:
            return {
                ...initialState,
                ...action.payload,
            };
        default:
            return state;
    }
};
